import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const isTop: TComputedPropMapper<boolean> = ({ offer: { isTop3 } }) => Boolean(isTop3);
